import { Component, inject } from '@angular/core';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mps-app-footer',
  imports: [TranslateModule],
  templateUrl: './mps-footer.component.html',
  styleUrls: ['./mps-footer.component.scss'],
})
export class MpsFooterComponent {
  private readonly translateService = inject(TranslateService);

  currentYear = new Date().getFullYear().toString();

  /** CGU ("mention d'usage") PDF, resolved to the active UI language (falls back to FR). */
  get cguHref(): string {
    return `assets/docs/cgu/cgu-${this.lang}.pdf`;
  }

  /** Legal notice ("mentions légales") PDF, resolved to the active UI language (falls back to FR). */
  get legalNoticeHref(): string {
    return `assets/docs/legal/legal-${this.lang}.pdf`;
  }

  /** Usage notice ("mentions d'usage") PDF, resolved to the active UI language (falls back to FR). */
  get usageHref(): string {
    return `assets/docs/usage/usage-${this.lang}.pdf`;
  }

  private get lang(): 'fr' | 'en' {
    return this.translateService.currentLang === 'en' ? 'en' : 'fr';
  }
}
